var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"bg-gray-lighten3 py-6 xl:py-8",attrs:{"id":_vm.data.id}},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"caption sm:max-w-[664px]",domProps:{"innerHTML":_vm._s(_vm.data.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }